import React, { ChangeEvent, SelectHTMLAttributes } from "react";

import Icon from "../Icon";
import { faAngleDown, faTimes } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "../Tooltip";

export interface SelectInputProps
  extends SelectHTMLAttributes<HTMLSelectElement> {
  value: string | number;
  options: {
    text: string;
    value?: string | number;
  }[];
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  register?: any;
  error?: any;
}

const SelectInput = ({
  value,
  options,
  onChange,
  register,
  error,
  ...props
}: SelectInputProps) => {
  return (
    <div className="relative w-full">
      <div className="absolute right-0 flex items-center h-full px-4">
        <Icon icon={faAngleDown} />
      </div>
      <label>
        <select
          className="z-0 w-full px-4 py-2 border border-gray-200 rounded-none outline-none appearance-none focus:outline-none"
          value={value}
          onChange={onChange}
          ref={register}
          {...props}
        >
          <option value="" disabled>
            Select option
          </option>
          {options.map((option, key) => (
            <option value={option.value} key={key}>
              {option.text}
            </option>
          ))}
        </select>
      </label>
      {error ? (
        <div className="absolute left-0 z-10 flex justify-center mt-1">
          <Tooltip theme="danger">
            <Icon icon={faTimes}></Icon> {error}
          </Tooltip>
        </div>
      ) : null}
    </div>
  );
};

export default SelectInput;
